import billingApiModule from '../billingApi.module';

class BillingSubscriptionApiService {
    constructor(__env, apiUtil, authenticationConstants) {
        this.__env = __env;
        this.apiUtil = apiUtil;
        this.authenticationConstants = authenticationConstants;
    }

    getSubscriptions() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/subscriptions`
        );
    }
}

export default billingApiModule.service(
    'billingSubscriptionApiService',
    BillingSubscriptionApiService
);



// WEBPACK FOOTER //
// ./modules/billingApi/subscription/billingSubscriptionApi.service.js